<template>
    <div id="catalog-menu">
        <div v-if="!isEditMenu" class="caption">
            <div class="title" @click="navigateTo(data)">
                {{ data.languageContent[$i18n.locale].name }}
                <md-button>
                    <md-icon>arrow_forward_ios</md-icon>
                </md-button>
            </div>
            <div class="actions">
                <span v-if="checkPermission(PERMISSION_TYPES['catalog.update'].tr.name)">
                    <md-button v-if="data.type === 'menu'" class="trash" @click="isEditMenu = true">
                        <md-icon>edit</md-icon>
                    </md-button>
                </span>
                <span v-if="checkPermission(PERMISSION_TYPES['catalog.delete'].tr.name)"
                    ><md-button class="trash" @click="deleteCatalog(data._id)">
                        <md-icon>delete</md-icon>
                    </md-button>
                </span>
            </div>
        </div>

        <b-tabs v-else>
            <MultiContent
                :is-text-area-visible="false"
                :input="catalogMenuUpdateObj"
                :input-change="formTitleChangeHandler"
                :prop-langs="{ object: catalogForm.languageContent, expansion: 'text' }"
                @language-deleted="onDeleteLanguage"
            />
            <button class="actionsButtonCancel" @click="isEditMenu = false">
                {{ $t("message.cancel") }}
            </button>
            <button class="actionsButton" @click="updatedMenu">
                {{ $t("message.update") }}
            </button>
        </b-tabs>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import MultiContent from "./MultiContent";
import { toObject2, toArray2 } from "../utils/languageContent";
import { PERMISSION_TYPES } from "../language/permissionTypes";

export default {
    name: "CatalogMenu",
    props: ["data", "navigateTo"],
    components: { MultiContent },
    data() {
        return {
            isEditMenu: false,
            catalogForm: null,
            newFormCatalogTitle: "",
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            languages: (state) => state.language.languages,
            isDarkMod: (state) => state.app.darkMode,
        }),
        catalogMenuUpdateObj: {
            get() {
                return toArray2(this.catalogForm, "languageContent", "name").languageContent;
            },
            set(value) {
                this.catalogForm.languageContent = toObject2(value, "name");
                this.addNewFormCatalogTitle();
            },
        },
    },
    methods: {
        ...mapActions({
            updateCatalog: "catalog/updateCatalog",
            deleteCatalog: "catalog/deleteCatalog",
        }),
        formTitleChangeHandler(value) {
            this.newFormCatalogTitle = value;
            this.addNewFormCatalogTitle();
        },
        addNewFormCatalogTitle() {
            Object.keys(this.newFormCatalogTitle).forEach((key) => {
                if (!this.catalogForm.languageContent[key]) {
                    return (this.catalogForm.languageContent[key] = {
                        languageCode: key,
                        content: "",
                        name: this.newFormCatalogTitle[key],
                    });
                }
                this.catalogForm.languageContent[key].name = this.newFormCatalogTitle[key];
            });
        },
        onDeleteLanguage(data) {
            this.catalogForm.languageContent = toObject2(data.content, "name");
            this.addNewFormCatalogTitle();
        },
        handleKeyDown({ code }) {
            if (code === "Enter") {
                this.updateCatalog(this.catalogForm);
                this.isEditMenu = false;
            }
        },

        updatedMenu() {
            this.updateCatalog(this.catalogForm);
            this.isEditMenu = false;
        },
    },
    mounted() {
        this.catalogForm = this.data;
    },
};
</script>

<style lang="scss" scoped>
#catalog-menu {
    .caption {
        display: flex;
        justify-content: center;
    }

    .title {
        padding: 0 8px;
        justify-content: center;
        align-items: center;
        display: flex;
        flex: 1;
        font-size: 16px;
    }

    .md-button {
        margin: 0;
        min-width: 10px;
    }

    .inputTitle {
        width: 100%;
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .actionsButton {
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .actionsButtonCancel {
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }
}
</style>
